const timestampToDate = (timestamp) => {
    if (timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return '';
}

const dateToTimestamp = (strDate) => {
    if (strDate) {
        const date = new Date(strDate);
        return date.getTime();
    }
    return null;
}

const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，因此需要加1
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}


export default {
    timestampToDate,
    getCurrentDate,
    dateToTimestamp
}